import {Ticket, Storage} from '@/utils';

const mutations = {
    initAppTheme(state) {
        state.appTheme = Ticket.get().theme;
    },
    getSystemInfo(state, data) {
        state.systemInfo = data;
    },
    initUserInfo(state) {
        state.userInfo = Ticket.get();
    },

    // 传 document.documentElement
    changeDocumentSize(state) {
        let rootElement = document.documentElement
        state.documentSize = {
            width: rootElement.clientWidth,
            height: rootElement.clientHeight
        }
    },

    getForLevelMenu(state, data) {
        state.forLevelMenu = data;
    },
    getTrainTypeMenu(state, data) {
        state.trainTypeMenu = data;
    },
    getTrainSpecialMenu(state, data) {
        state.trainSpecialMenu = data;
    },
    getTrainModeMenu(state, data) {
        state.trainModeMenu = data;
    },
    getGroupMenu(state, data) {
        state.groupMenu = data;
    },
    getExamFormMenu(state, data) {
        state.examFormMenu = data;
    },
    getPositionMenu(state, data) {
        state.positionMenu = data;
    },
    getUserTypeMenu(state, data) {
        state.userTypeMenu = data;
    },
    getOrgTree(state, data) {
        state.orgTree = data;
    },
    getCourseTypeMenu(state, data) {
        state.courseTypeMenu = data;
    },
    getPaperTypeMenu(state, data) {
        state.paperTypeMenu = data;
    },
    getDifficultyMenu(state, data) {
        state.difficultyMenu = data;
    },
    getTopicTypeMenu(state, data) {
        state.topicTypeMenu = data;
    },
    getPaperMethodMenu(state, data) {
        state.paperMethodMenu = data;
    },
    getKnowledgeMenu(state, {type, data}) {
        state.knowledgeMenu = Object.assign({}, state.knowledgeMenu, {[type]: data});
    },
    getSystemKnowledgeMenu(state, {type, data}) {
        state.systemKnowledgeMenu = Object.assign({}, state.systemKnowledgeMenu, {[type]: data});
    },
    getMarkKnowledgeMenu(state, data) {
        state.markKnowledgeMenu = data;
    },
    getExamStatusMenu(state, data) {
        state.examStatusMenu = data;
    },
    getCertTypesMenu(state, data) {
        state.certTypesMenu = data;
    },
    getPreJobMenu(state, data) {
        state.preJobMenu = data;
    },
    getViewCountMenu(state, data) {
        state.viewCountMenu = data;
    },
    getImageOriginMenu(state, data) {
        state.imageOriginMenu = data;
    },
    getLedgerOriginMenu(state, data) {
        state.ledgerOriginMenu = data;
    },
    getUploadTop(state, data) {
        state.uploadTop = data;
    },
    getProjectTypeMenu(state, data) {
        state.projectTypeMenu = data;
    },
    getKnowledgeTypeMenu(state, data) {
        state.knowledgeTypeMenu = data;
    },

    initUserTrainSetting(state, data) {
        let userID = Ticket.get().userID
        let key = `userTrainSetting-${userID}`
        state.userTrainSetting = Storage.get(key) || {}

        if (data) {
            Storage.set(key, data)
            state.userTrainSetting = data
        }
    },
    getCreditTypeMenu(state, data) {
        state.creditTypeMenu = data;
    },
    getRankTypeMenu(state, data) {
        state.rankTypeMenu = data;
    },
    getFiscanProductMenu(state, data) {
        state.fiscanProductMenu = data;
    },

    startWSBrowser(state, connection) {
        state.wsBrowser = connection
    },
    stopWSBrowser(state) {
        state.wsBrowser?.stop()
        state.wsBrowser = null
    },
    startWSTrainee(state, connection) {
        state.wsTrainee = connection
    },
    stopWSTrainee(state) {
        state.wsTrainee?.stop()
        state.wsTrainee = null
    },
};

export default mutations
